const UNSUPPORTED_PROTOCOL = /^(?:mailto:|tel:|javascript:|data:)/i;
const DOWNLOAD_PATH = /\.(?:csv|docx?|jpe?g|png|pdf|svg|webp|xlsx?|zip)(?:[?#]|$)/i;
// Google tag si proklik z reklamy uloží až po souhlasu, často o několik stránek dál.
const AD_CLICK_IDS = new Set(['gclid', 'gbraid', 'wbraid']);

const isUnsupportedTarget = (target : string) : boolean => (
    target.startsWith('#')
    || UNSUPPORTED_PROTOCOL.test(target)
    || DOWNLOAD_PATH.test(target)
);

export const preserveUtmParams = (target : string, currentUrl : string) : string => {
    if (!target || isUnsupportedTarget(target)) {
        return target;
    }

    try {
        const current = new URL(currentUrl);
        const destination = new URL(target, current);

        if (destination.origin !== current.origin) {
            return target;
        }

        const destinationKeys = new Set(destination.searchParams.keys());
        let changed = false;

        current.searchParams.forEach((value, key) => {
            if ((key.startsWith('utm_') || AD_CLICK_IDS.has(key)) && value && !destinationKeys.has(key)) {
                destination.searchParams.append(key, value);
                changed = true;
            }
        });

        if (!changed) {
            return target;
        }

        if (/^https?:\/\//i.test(target)) {
            return destination.toString();
        }

        return `${destination.pathname}${destination.search}${destination.hash}`;
    } catch {
        return target;
    }
};
